<ng-container *ngIf="portfolios.length > 0; else noData">
  <div class="card-header"
       style="padding-bottom: 0.5rem; ">
    <div class="grid-x">
      <div class="cell auto">
        <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">
          {{"widget.name.DEDICATED_CONSULTANT_PLURAL" | translate : {count: portfolioConsultants.length} }}
        </h4>
      </div>
      <div class="cell shrink">
        <span (click)="previousPortfolio()"
              [ngClass]="{'c-light-gray': isFirstPortfolio(),
                          'c-medium-gray': !isFirstPortfolio()}"
              [ngStyle]="{'pointer-events': isFirstPortfolio() ? 'none' : 'auto'}"
              class="cursor-hover fas fa-chevron-circle-left margin-r-xs"></span>
        <span class="c-dark-gray margin-r-xs"
              style="font-weight: 500">
          {{currentPortfolio.solution | applicationName}}
        </span>
        <span (click)="nextPortfolio()"
              [ngClass]="{'c-light-gray': isLastPortfolio(),
                          'c-medium-gray': !isLastPortfolio()}"
              [ngStyle]="{'pointer-events': isLastPortfolio() ? 'none' : 'auto'}"
              class="cursor-hover fas fa-chevron-circle-right"></span>
      </div>
    </div>
  </div>

  <div class="card-body" style="padding: 0 10px; max-height: none; height: 155px;">
    <div class="grid-x" style="height: inherit">
      <div class="cell shrink margin-r-l"
           style="width: 50%; display: flex; flex-direction: column"
           [ngStyle]="{'justify-content': (portfolioConsultants.length > 1) ? 'space-between' : 'center' }">
        <div style="display: flex;align-items: center;justify-content: center; flex-direction: column;">

          <div class="margin-b-s" style="width:75px;height:75px; border-radius: 45px; -webkit-border-radius: 45px; -moz-border-radius: 45px;"
               [style.background]="' no-repeat center/contain url('+ this.mainPortfolioConsultant.pictureUrl +')'">
          </div>
          <h4 class="c-dark-gray font-bold text-center">
            {{ this.mainPortfolioConsultant.lastname + ' ' + this.mainPortfolioConsultant.firstname }}
          </h4>
          <p class="c-medium-gray text-center" style="margin: unset;">
            {{ this.mainPortfolioConsultant.jobTitle }}
          </p>

        </div>
        <div *ngIf="portfolioConsultants.length > 1"
             style="display: flex; padding: unset;align-items: center">
          <div style="display: flex;
                      width: 100%;
                      justify-content: center;
                      padding-bottom: 6px">
            <a class="button insito fa-regular fa-2x fa-phone c-insito action margin-r-s"
               (click)="onCreateNewAssistanceRequest()">
            </a>
            <a class="fa fa-2x fa-cog button insito c-insito action margin-r-s"
               [href]="accessValidationUrl"
               target="_blank"
               (click)="onNavigateToAccessValidation()">
            </a>
            <a class="button insito action"
               (click)="onClickOnOpenSolutionAssistancesListDialog()">
              <span [title]="'widget.dedicated-consultant.display-tickets' | translate">
                {{'widget.dedicated-consultant.display-tickets' | translate}}
              </span>
            </a>
          </div>
        </div>
      </div>

      <ng-container *ngIf="portfolioConsultants.length > 1; else displayActions">
        <div class="cell auto"
             style="width: 50%; display: flex;
                  justify-content: flex-start;
                  flex-direction: column;
                  align-items: flex-start;
                  height: inherit;">
          <ng-container *ngFor="let consultant of portfolioConsultants | sortByOrder">
            <div class="grid-x border-radius-default cursor-hover padding-all-xs"
                 style="width: 100%"
                 [ngStyle]="{'background-color': (consultant.id === mainPortfolioConsultant.id) ? '#DFF4F4' : 'unset'}"
                 (click)="switchMainConsultant(consultant.id)">
              <div class="cell shrink margin-r-s">
                <div style="width:18px;height:18px; border-radius: 45px; -webkit-border-radius: 45px; -moz-border-radius: 45px;"
                     [style.background]="' no-repeat center/contain url('+ this.consultant.pictureUrl +')'">
                </div>
              </div>
              <div class="cell auto"
                   style="align-items: center;display: flex;">
                <h4 class="c-dark-gray text-center"
                    [ngClass]="{'font-bold': (consultant.id === mainPortfolioConsultant.id)}">
                  {{ this.consultant.lastname + ' ' + this.consultant.firstname }}
                </h4>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #displayActions>
        <div class="cell auto"
             style="width: 50%; display: flex;
                  justify-content: center;
                  flex-direction: column;
                  align-items: flex-start;
                  height: inherit;">
          <a class="button insito c-insito action margin-b-s"
             style="width: 100%; text-align: left"
             (click)="onCreateNewAssistanceRequest()">
            <span class="fa-regular fa-lg fa-phone"></span>
            <span [title]="'widget.dedicated-consultant.contact-consultant' | translate"
                  class="margin-l-s">
              {{ 'widget.dedicated-consultant.contact-consultant' | translate }}
            </span>
          </a>
          <a class="button insito c-insito action margin-b-s"
             style="width: 100%; text-align: left"
             [href]="accessValidationUrl"
             target="_blank"
             (click)="onNavigateToAccessValidation()">
            <span class="fa-regular fa-lg fa-cog"></span>
            <span [title]="'widget.dedicated-consultant.user-access' | translate"
                  class="margin-l-s">
              {{ 'widget.dedicated-consultant.user-access' | translate }}
            </span>
          </a>
          <a class="button insito action margin-b-s"
             style="width: 100%; text-align: left"
             (click)="onClickOnOpenSolutionAssistancesListDialog()">
            <span class="fa-regular fa-lg fa-circle-info"></span>
            <span [title]="'widget.dedicated-consultant.display-tickets' | translate"
                  class="margin-l-s">
              {{'widget.dedicated-consultant.display-tickets' | translate}}
            </span>
          </a>
        </div>
      </ng-template>
    </div>
  </div>
</ng-container>

<ng-template #noData>
  <ng-container *ngIf="portfolios.length === 0">
  <app-widget-message [message]="'service.not-configured' | translate"
                      [widgetLabel]="'widget.name.'.concat(widget.widgetName) | translate : {count: 2}"
                      [widgetSize]="widget.size"
                      icone="opt-stat"></app-widget-message>
  </ng-container>
  <ng-container *ngIf="portfolios === null">
    <app-widget-message [message]="'service.non-available' | translate"
                        [widgetLabel]="'widget.name.'.concat(widget.widgetName) | translate : {count: 2}"
                        [widgetSize]="widget.size"
                        icone="opt-stat"></app-widget-message>
  </ng-container>
</ng-template>
